import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import memberApi from '../../lib/memberApi';
import { AuthLayout, inputCls } from '../../components/member/AuthLayout';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== password2) {
      toast.error('Şifreler eşleşmiyor');
      return;
    }
    setIsSubmitting(true);
    try {
      await memberApi.post('/members/auth/reset', { token, password });
      toast.success('Şifreniz güncellendi');
      navigate('/uye/giris');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'İşlem başarısız');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!token) {
    return (
      <AuthLayout title="Geçersiz Bağlantı" testid="reset-invalid">
        <p className="text-sm text-muted-foreground text-center">Bu bağlantı geçersiz. Lütfen yeni bir sıfırlama talebi oluşturun.</p>
        <div className="text-center mt-4">
          <Link to="/uye/sifremi-unuttum" className="text-sm text-[hsl(var(--gold))] font-medium hover:underline">Şifremi unuttum</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Yeni Şifre Belirle" subtitle="Hesabınız için yeni bir şifre oluşturun" testid="reset-page">
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-form">
        <div>
          <label className="block text-sm font-medium mb-1.5">Yeni Şifre</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required minLength={6} data-testid="reset-password" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">Yeni Şifre (Tekrar)</label>
          <input type="password" value={password2} onChange={(e) => setPassword2(e.target.value)} className={inputCls} required minLength={6} data-testid="reset-password2" />
        </div>
        <button type="submit" disabled={isSubmitting}
          className="w-full px-4 py-2.5 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] font-medium text-sm hover:bg-[hsl(var(--gold)/0.92)] active:scale-[0.98] transition-colors duration-200 disabled:opacity-50"
          data-testid="reset-submit">
          {isSubmitting ? 'Güncelleniyor...' : 'Şifreyi Güncelle'}
        </button>
      </form>
    </AuthLayout>
  );
}
